import { LeadStatusCountsGrouped } from "../../types/lead.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = `${import.meta.env.VITE_API_URL}/dashboard`;

const makeRequestDebounced = createDebounce(makeRequest, 200);
const makeRequestDebouncedLeads = createDebounce(makeRequest, 200);

export async function getDashboard({ startDate = "", endDate = "" }) {
  const params = new URLSearchParams({ startDate, endDate });

  const url = `${API_URL}/leads/customer?${params.toString()}`;

  return await makeRequestDebouncedLeads(url) as ApiResponseType<LeadStatusCountsGrouped>;
}


const makeRequestDebouncedPlan = createDebounce(makeRequest, 200);
// export async function getRenterPlansDashboard() {
//   const url = `${API_URL}/renters/plans/customers`;
//   return await makeRequestDebouncedPlan(url) as ApiResponseType<unknown>;

// }


export async function getConvertedRentersDashboard({
  startDate = "",
  endDate = "",
  companyId = "",
}: {
  startDate?: string;
  endDate?: string;
  companyId?: string;
}) {
  const params = new URLSearchParams({ startDate, endDate });
  if (companyId && companyId !== "*") params.append("companyId", companyId);

  const url = `${API_URL}/renters/customer?${params.toString()}`;
  return await makeRequestDebounced(url) as ApiResponseType<{
    filter: {
      converted: number;
      reactivations: number;
      activations: number;
      activationsByConsultant?: {
        activations: number;
        reactivations: number;
        technicalConsultant: string;
        city?: string;
      }[];
    },
    filterToday: {
      converted: number;
      reactivations: number;
      activations: number;
    }
  }>;
}

export async function getRenterPlansDashboard(companyId?: string) {
  const params = new URLSearchParams();
  if (companyId && companyId !== "*") params.append("companyId", companyId);

  const url = `${API_URL}/renters/plans/customers?${params.toString()}`;
  return await makeRequestDebouncedPlan(url) as ApiResponseType<unknown>;
}
